/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 7/17/20
 *
 */

export const DisplayDestinationEnum = Object.freeze({
	COACH_JOURNAL: "COACH_JOURNAL",
	CLIENT_JOURNAL_FOR_COACH: "CLIENT_JOURNAL_FOR_COACH",
	CLIENT_JOURNAL_FOR_CLIENT: "CLIENT_JOURNAL_FOR_CLIENT",
})

export function getDestinationIndex(destinationArray){
	return destinationArray.sort((l, r) => l > r).reduce((res, val) => `${res};${val}`, "")
}
export function getDestinationArrayFromIndex(destinationIndex){
	if(destinationIndex){
		return destinationIndex.split(";")
	}
}

